import GatewayAddHeader from './GatewayAddHeader'
import GateWayMainForm from './GatewayMainForm'

const GatewayForm = () => {
  return (
    <div>
      <GatewayAddHeader />
      <GateWayMainForm />
    </div>
  )
}
export default GatewayForm
